module.exports = __webpack_public_path__ + "static/hardware1-3145f650d266a6b75d33a47bf78d25ac.jpg";